/**
 * Platform bootstrap defaults — keep in sync with
 * portal-backend/app/utils/websiteConfigBootstrap.js
 * Source: https://wulooj.com/
 */
export const WULOOJ_BRAND = {
  name: "Wulooj",
  logoUrl: "/assets/wulooj-logo.svg",
  faviconUrl: "/assets/wulooj-icon.svg",
}

export const WULOOJ_THEME = {
  primaryColor: "#5828A3",
  secondaryColor: "#AA90D3",
  primaryLight: "#F3E8FF",
  primaryDeep: "#23164C",
  fontFamily: '"Plus Jakarta Sans", "Cairo", system-ui, sans-serif',
  fontDisplay: '"Sora", "Plus Jakarta Sans", "Cairo", system-ui, sans-serif',
  pageBackground: {
    colorStart: "#F3E8FF",
    colorEnd: "#F3E8FF",
    direction: "to bottom",
  },
  buttons: {
    backgroundColor: "#5828A3",
    textColor: "#FFFFFF",
    borderRadius: 12,
    compactBorderRadius: 10,
  },
  inputs: {
    backgroundColor: "#FFFFFF",
    textColor: "#23164C",
    borderColor: "#E8DDF5",
    borderRadius: 12,
  },
  radios: {
    borderRadius: 999,
    borderColor: "#C4B5D6",
    selectedBorderColor: "#5828A3",
    textColor: "#6B5B7A",
    selectedTextColor: "#5828A3",
    dotColor: "#5828A3",
    backgroundColor: "#FFFFFF",
  },
}

export const WULOOJ_TOP_AD = {
  backgroundColor: "#EDE4F7",
  textColor: "#23164C",
  messages: [
    {
      en: "Beyond Digital Into AI",
      ar: "ما بعد الرقمنة نحو الذكاء الاصطناعي",
    },
    {
      en: "Trusted by 100K+ companies worldwide",
      ar: "موثوق من أكثر من 100 ألف شركة حول العالم",
    },
    {
      en: "Web, mobile, AI & custom software — one integrated studio",
      ar: "ويب، جوال، ذكاء اصطناعي وحلول مخصصة — استوديو متكامل واحد",
    },
  ],
}

export const WULOOJ_HERO = {
  layout: "carousel",
  useMenuBanners: true,
  headline: {
    en: "We Build Digital Excellence",
    ar: "نبني التميز الرقمي",
  },
  subheadline: {
    en: "Transforming ambitious ideas into powerful digital realities using cutting-edge technology and premium design",
    ar: "نحوّل الأفكار الطموحة إلى واقع رقمي قوي باستخدام أحدث التقنيات والتصميم المتميز",
  },
  ctaText: { en: "Start Project", ar: "ابدأ مشروعك" },
  ctaLink: "/contact",
  backgroundImage: "",
  badgeFallback: { en: "New", ar: "جديد" },
}

export const WULOOJ_CONTACT = {
  email: "hello@wulooj.com",
  phone: "",
  address: {
    en: "Riyadh, Saudi Arabia",
    ar: "الرياض، المملكة العربية السعودية",
  },
  poBox: "",
  cityLine: {
    en: "Kingdom of Saudi Arabia",
    ar: "المملكة العربية السعودية",
  },
  mapEmbed: "",
}

export const WULOOJ_SOCIAL = {
  facebook: "",
  instagram: "https://www.instagram.com/wulooj",
  twitter: "https://x.com/wulooj/",
  linkedin: "https://www.linkedin.com/company/wulooj/",
  youtube: "",
  tiktok: "",
  snapchat: "",
  whatsapp: "",
}

export const WULOOJ_FOOTER = {
  backgroundColor: "#F3E8FF",
  textColor: "#5828A3",
  about: {
    en: "Transforming ambitious ideas into powerful digital realities using cutting-edge technology and premium design.",
    ar: "نحوّل الأفكار الطموحة إلى واقع رقمي قوي باستخدام أحدث التقنيات والتصميم المتميز.",
  },
  appLinks: {
    ios: {
      url: "",
      label: { en: "App Store", ar: "آب ستور" },
      imageUrl: "/assets/appstore.png",
    },
    android: {
      url: "",
      label: { en: "Google Play", ar: "جوجل بلاي" },
      imageUrl: "/assets/playstore.png",
    },
  },
  policies: {
    title: { en: "Policies", ar: "السياسات" },
    links: [
      {
        label: { en: "Privacy Policy", ar: "سياسة الخصوصية" },
        href: "/privacy",
      },
      {
        label: { en: "Terms and Conditions", ar: "الشروط والأحكام" },
        href: "/terms",
      },
    ],
  },
  importantLinks: {
    title: { en: "Help", ar: "المساعدة" },
    links: [
      {
        label: { en: "FAQs", ar: "الأسئلة الشائعة" },
        href: "/faq",
      },
    ],
  },
  social: {
    title: { en: "Follow us", ar: "تابعنا" },
    platforms: [
      {
        id: "twitter",
        label: "X",
        url: "https://x.com/wulooj/",
        iconUrl: "/assets/prime_twitter.png",
      },
      {
        id: "instagram",
        label: "Instagram",
        url: "https://www.instagram.com/wulooj",
        iconUrl: "/assets/instagram.png",
      },
      {
        id: "linkedin",
        label: "LinkedIn",
        url: "https://www.linkedin.com/company/wulooj/",
        iconUrl: "/assets/linkedin.svg",
      },
    ],
  },
  payments: [
    { id: "apple-pay", label: "Apple Pay", iconUrl: "" },
    { id: "mada", label: "mada", iconUrl: "" },
    { id: "mastercard", label: "Mastercard", iconUrl: "" },
    { id: "visa", label: "Visa", iconUrl: "" },
  ],
  copyright: {
    en: "© 2026 Wulooj | All Rights Reserved",
    ar: "© 2026 Wulooj | جميع الحقوق محفوظة",
  },
  vatNumber: "",
  commercialRegisterNumber: "",
}

export const WULOOJ_CONTENT = {
  footer: {
    about: WULOOJ_FOOTER.about,
  },
  sections: {
    categories: { en: "Our Services", ar: "خدماتنا" },
    featured: { en: "Featured Work", ar: "أعمال مميزة" },
    offers: { en: "Case Studies", ar: "دراسات حالة" },
  },
  sectionSubtitles: {
    featured: {
      en: "Product strategy, design, and engineering in one team.",
      ar: "استراتيجية المنتج والتصميم والهندسة في فريق واحد.",
    },
    offers: {
      en: "Real outcomes from web, mobile, and custom software projects.",
      ar: "نتائج حقيقية من مشاريع الويب والجوال والبرمجيات المخصصة.",
    },
  },
  offerTitleFallback: { en: "Project", ar: "مشروع" },
  promoMessages: WULOOJ_TOP_AD.messages,
  trustStrip: {
    label: { en: "Why choose us", ar: "لماذا تختارنا" },
    items: [
      {
        title: { en: "Trusted quality", ar: "جودة موثوقة" },
        copy: {
          en: "Built with care for every customer",
          ar: "نبني تجربة بعناية لكل عميل",
        },
      },
      {
        title: { en: "Fresh & reliable", ar: "طازج وموثوق" },
        copy: {
          en: "Consistent experience every time",
          ar: "تجربة متسقة في كل مرة",
        },
      },
      {
        title: { en: "Fast service", ar: "خدمة سريعة" },
        copy: {
          en: "Quick ordering and smooth delivery",
          ar: "طلب سريع وتوصيل سلس",
        },
      },
    ],
  },
}

export const WULOOJ_SEO = {
  metaTitle: {
    en: "Wulooj — Digital Products & Software",
    ar: "Wulooj — منتجات رقمية وبرمجيات",
  },
  metaDescription: {
    en: "Wulooj builds web, mobile, AI, and custom software solutions with strategy, design, and engineering in one studio.",
    ar: "Wulooj تبني حلول الويب والجوال والذكاء الاصطناعي والبرمجيات المخصصة مع الاستراتيجية والتصميم والهندسة في استوديو واحد.",
  },
  ogImage: "",
}
